module.exports = __webpack_public_path__ + "img/fusion-power-station.e6384ff0.png";